import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    acceptedTasks: {},
    taskDrafts: {},
};

const taskSlice = createSlice({
    name: "task",
    initialState,
    reducers: {
        acceptTask: (state, action) => {
            const taskId = action.payload;
            state.acceptedTasks[taskId] = true;
        },
        revokeTask: (state, action) => {
            const taskId = action.payload;
            delete state.acceptedTasks[taskId];
        },
        clearAllTasks: (state) => {
            state.acceptedTasks = {};
        },
        saveTaskDraft: (state, action) => {
            const { taskId, data } = action.payload;
            if (!state.taskDrafts) {
                state.taskDrafts = {};
            }
            state.taskDrafts[taskId] = data;
        },
        removeTaskDraft: (state, action) => {
            if (!state.taskDrafts) return;
            delete state.taskDrafts[action.payload];
        },
    },
});

export const { acceptTask, revokeTask, clearAllTasks, removeTaskDraft, saveTaskDraft } = taskSlice.actions;
export default taskSlice.reducer;